/* eslint-disable @typescript-eslint/no-explicit-any */

import { paramCase } from 'change-case'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { doNothing } from '../../helpers/functions/doNothing'
import { DesktopStandard, MobileStandard } from './displays'
import { styles } from './styles'

interface Props {
  accountImage: AssetReference | null
  accountName: string
  assets: AssetReference[]
  display: string
  isPresenting?: boolean
  onExpandAsset?: (assetId: number) => void
  onRemoveAsset?: (assetId: number) => void
  readOnly: boolean
}

const displays: { [key: string]: React.FC<any> } = {
  default: MobileStandard,
  desktopStandard: DesktopStandard,
  mobileStandard: MobileStandard,
}

const matchDisplay = (display: string): React.FC<any> =>
  displays[display] || displays.default

export const YouTubeChannelUpdate: React.FC<Props> = ({
  accountImage,
  accountName,
  assets,
  display,
  isPresenting,
  onExpandAsset,
  onRemoveAsset,
  readOnly,
}) => {
  const RenderDisplay = matchDisplay(display)
  const image = assets && assets[0] ? assets[0] : null

  return (
    <div
      css={styles.getDisplay(display)}
      className={kuiperClassNames(
        'youtube youtube-channel-update',
        `youtube-${paramCase(display)}`
      )}
    >
      <RenderDisplay
        accountImage={accountImage}
        accountName={accountName}
        image={image}
        isPresenting={isPresenting === undefined ? false : isPresenting}
        onExpandAsset={onExpandAsset ? onExpandAsset : doNothing}
        onRemoveAsset={onRemoveAsset ? onRemoveAsset : doNothing}
        readOnly={readOnly}
      />
    </div>
  )
}
